<template>
	<div id="nav" class="subheading-2 mobile-caption-1">
		<!-- Default -->
		<a href="/myqiagen" class="my-qiagen-crumb">My QIAGEN</a>
		<span><base-icon class="nav_icon" icon-name="chevron-right" icon-size="16px" /></span>
		<!-- Workflows in nav -->
		<template v-if="this.$route.name !== 'MyWorkflows'">
			<a
        href="/workflows"
				@click.prevent="warnUserToSaveBeforeLeave"
				class="workflows-crumb"
				:class="isHomePage && 'active-link'"
				>Experiments</a
			>
		</template>

		<!-- Worflow Entry Points in nav -->
		<template v-if="extraPath && this.$route.name === 'Workflow'">
			<span><base-icon class="nav_icon" icon-name="chevron-right" icon-size="16px" /></span>
			<router-link
				:to="{name: 'Workflow', params: {...$route.params}}"
				:class="{'router-link-active router-link-exact-active': extraPath}"
				class="extra-path-crumb"
				>{{ extraPath }} </router-link
			>
		</template>

		<!-- My Workflow in nav-->
		<template v-if="this.$route.name === 'MyWorkflows'">
			<a
				href="#"
				@click.prevent
				class="router-link-active router-link-exact-active my-workflows-crumb">My Experiments</a>
		</template>
	</div>
</template>

<script>
export default {
	methods: {
		warnUserToSaveBeforeLeave() {
			if (this.$route.name === 'Workflow') this.$root.$emit('wantToLeaveModal');
			else this.$router.push({name: 'Home', query: {}}).catch((err) => err);
		},
	},
	computed: {
		extraPath() {
			if (this.$route.name === 'Home') return '';
			if (this.$route.name === 'MyWorkflows') return 'My Experiments';
			return this.$store.state.workflowDefaultHeadline;
		},
    isHomePage() {
      return this.$route.name === 'Home';
    },
	},
};
</script>

<style lang="scss" scoped>
#nav {
	margin-top: 30px; // might need to be adjusted based on height of qiagen nav
	color: $color-grey-5;
	.nav_icon {
		margin: 0 12px;
	}
	.extra-path-crumb,
	.my-workflows-crumb {
		color: $color-blue;
	}
	.extra-path-crumb:hover,
	.my-workflows-crumb:hover {
		cursor: text;
		text-decoration: none;
	}
	.workflows-crumb,
	.my-qiagen-crumb {
		color: $color-grey-5;
	}
	.workflows-crumb:hover,
	.my-qiagen-crumb:hover {
		cursor: pointer;
    text-decoration: underline;
		text-decoration-thickness: auto;
		text-decoration-color: $color-grey-5;
	}
  .active-link {
    color: $color-blue;
      cursor: text;

    &:hover {
      text-decoration: none;
      cursor: text;
    }
  }
	@media (max-width: $mobile) {
		.nav_icon {
			position: relative;
			top: 1px;
		}
	}
	@media (min-width: $tablet) {
		margin-top: 23px;
	}
}
</style>
